<template>
  <div class="icon-cont">
    <svg
      class="icon-svg"
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      fill-rule="nonzero"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect
        x="0"
        y="0"
        width="18"
        height="18"
        fill="none"
        stroke-width="2"
      />
      <rect
        x="4"
        y="8"
        width="10"
        height="2"
        fill="inherit"
        stroke-width="0"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'RareExpandPane',
  data() {
    return {
      isHovered: false,
    };
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .icon-cont {
    cursor: pointer;
    display: inline-block;
    width: 18px;
    height: 18px;
  }

  .icon-svg {
    margin-top: -1px;
    margin-left: -11px;
    fill: #b4bfc8;
    stroke: #b4bfc8;
  }

  .icon-svg:hover {
    fill: white;
    background-color: #b4bfc8;
  }

</style>
